interface MarkProps { size?: number; bg?: 'paper' | 'ink' | 'transparent'; }

export function Mark({ size = 32, bg = 'paper' }: MarkProps) {
  const inv = bg === 'ink';
  const sqBg = inv ? '#F4ECDB' : '#1A1612';
  const sqInk = inv ? '#1A1612' : '#F4ECDB';
  const frame = inv ? '#1A1612' : '#A77D2E';
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" aria-hidden style={{ display: 'block', flexShrink: 0 }}>
      <rect x="6" y="6" width="188" height="188" fill={sqBg} />
      <rect x="6" y="6" width="188" height="188" fill="none" stroke={frame} strokeWidth="2.4" />
      <text x="100" y="138" textAnchor="middle" fill={sqInk}
            fontFamily="DM Serif Display, Georgia, serif" fontSize="120" fontWeight="400">
        IA
      </text>
    </svg>
  );
}

export function Lockup({ size = 28, tone = 'ink' }: { size?: number; tone?: 'ink' | 'paper' }) {
  const ink = tone === 'paper' ? 'var(--paper)' : 'var(--ink)';
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <Mark size={size} bg="paper" />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span style={{
          fontFamily: 'var(--font-display)',
          fontSize: size * 0.74,
          letterSpacing: '-0.03em',
          color: ink,
        }}>
          Ifa <em style={{ fontStyle: 'italic', color: 'var(--ember)' }}>App</em>
        </span>
        <span style={{
          fontFamily: 'var(--font-word)',
          fontSize: size * 0.28,
          letterSpacing: '0.34em',
          color: 'var(--brass)',
          marginTop: 4,
        }}>
          ADMIN
        </span>
      </div>
    </div>
  );
}
